import { useState } from 'react';
import { getTabList as getTabListRequest } from 'src/services/client';

export interface FetchTabListResult {
  ok: boolean;
  tabList: any[];
}

export interface UseTabsAPIReturn {
  tabList: any[];
  isLoadingTabList: boolean;
  fetchTabList: () => Promise<FetchTabListResult>;
}

const unwrapArrayPayload = (result: any): any[] => {
  if (Array.isArray(result)) {
    return result;
  }

  return result?.data || [];
};

export const useTabsAPI = (): UseTabsAPIReturn => {
  const [tabList, setTabList] = useState<any[]>([]);
  const [isLoadingTabList, setIsLoadingTabList] = useState<boolean>(false);

  const fetchTabList = async (): Promise<FetchTabListResult> => {
    setIsLoadingTabList(true);

    try {
      const response: any = await getTabListRequest();

      if (!response.ok && response.status !== 200) {
        throw new Error(`Failed to fetch tab list: ${response.status}`);
      }

      const result: any = await response.json();
      const nextTabList: any[] = unwrapArrayPayload(result);

      setTabList(nextTabList);
      setIsLoadingTabList(false);

      return { ok: true, tabList: nextTabList };
    } catch (err: any) {
      console.error('useTabsAPI fetchTabList failed:', err);

      setIsLoadingTabList(false);

      return { ok: false, tabList: [] };
    }
  };

  return {
    tabList,
    isLoadingTabList,
    fetchTabList,
  };
};